<script setup>
import { useI18n } from 'vue-i18n';
import Input from 'dashboard/components-next/input/Input.vue';
import Button from 'dashboard/components-next/button/Button.vue';

const { t } = useI18n();

const options = defineModel({
  type: Array,
  default: () => [],
});

const addOption = () => {
  options.value = [...options.value, ''];
};

const removeOption = index => {
  options.value = options.value.filter((_, i) => i !== index);
};

const updateOption = (index, value) => {
  options.value = options.value.map((option, i) =>
    i === index ? value : option
  );
};
</script>

<template>
  <div class="flex flex-col gap-2">
    <div
      v-for="(option, index) in options"
      :key="index"
      class="flex items-center gap-2"
    >
      <Input
        :model-value="option"
        class="flex-1"
        :placeholder="
          t('ATTRIBUTES_MGMT.ADD.FORM.TYPE.LIST.OPTION_PLACEHOLDER')
        "
        @update:model-value="value => updateOption(index, value)"
      />
      <Button
        type="button"
        icon="i-lucide-trash-2"
        slate
        ghost
        xs
        @click="removeOption(index)"
      />
    </div>
    <Button
      type="button"
      link
      iris
      xs
      class="self-start"
      :label="t('ATTRIBUTES_MGMT.ADD.FORM.TYPE.LIST.ADD_OPTION')"
      @click="addOption"
    />
  </div>
</template>
